// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BottomText_Wrapper__vMpi5","TextBlack":"BottomText_TextBlack__3XISU","TextOrange":"BottomText_TextOrange__1efEG","BorderLine":"BottomText_BorderLine__2uiAr"};